import { render } from "./CloseIcon16.vue.js?vue&type=template&id=2e057c08!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./CloseIcon16.vue?vue&type=template&id=2e057c08"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__